// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* ======================== */
  /* COSMOS CSS VARS OVERRIDE */
  /* ======================== */

  /* TOOLTIP */
  --hc-tooltip-background-color: rgb(var(--hc-color-neutral-900));
  --hc-tooltip-show-opacity: 1;
  --hc-tooltip-arrow-before-background-color: rgb(var(--hc-color-neutral-900));
  --hc-tooltip-color: rgb(var(--hc-color-neutral-100));

  --hc-timing: 500ms;
}
`, "",{"version":3,"sources":["webpack://./src/config/cosmos/cosmos-overrides.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;;EAE7B,YAAY;EACZ,+DAA+D;EAC/D,4BAA4B;EAC5B,4EAA4E;EAC5E,oDAAoD;;EAEpD,kBAAkB;AACpB","sourcesContent":[":root {\n  /* ======================== */\n  /* COSMOS CSS VARS OVERRIDE */\n  /* ======================== */\n\n  /* TOOLTIP */\n  --hc-tooltip-background-color: rgb(var(--hc-color-neutral-900));\n  --hc-tooltip-show-opacity: 1;\n  --hc-tooltip-arrow-before-background-color: rgb(var(--hc-color-neutral-900));\n  --hc-tooltip-color: rgb(var(--hc-color-neutral-100));\n\n  --hc-timing: 500ms;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
